"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createStyles = _interopRequireDefault(require("../utils/createStyles"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = theme => _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  label: {
    fontFamily: theme.label.fontFamily,
    color: 'inherit',
    transition: theme.transition(['color']),
    '&.disabled': {
      opacity: theme.disabledOpacity
    },
    '&.hidden': {
      display: 'none'
    },
    '&.error': {
      color: `${theme.label.errorColor} !important`
    },
    '& b': {
      fontWeight: theme.label.fontWeight.semibold
    }
  }
}, (0, _createStyles.default)('textAlign', theme.label.textAlign)), (0, _createStyles.default)('color', theme.palette)), (0, _createStyles.default)('fontSize', theme.label.fontSize)), (0, _createStyles.default)('fontWeight', theme.label.fontWeight)), {}, {
  overflow__cut: {
    display: 'inline-block',
    overflow: 'hidden',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    wordBreak: 'break-all',
    height: theme.label.lineHeight,
    // If it's supported by browser - use another approach to add ellipsis (...)
    '@supports (display: -webkit-box) and (-webkit-box-orient: vertical) and (-webkit-line-clamp: 1)': {
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      'text-overflow': 'ellipsis',
      '-webkit-line-clamp': 1
    }
  },
  overflow__break: {
    wordBreak: 'break-word'
  }
});
exports.default = _default;